import React from 'react';
import { useReveal } from '../lib/useReveal';
const DREAMS = ['Crear tortas modernas y premium', 'Tener un Instagram hermoso', 'Vender box dulces modernas', 'Generar ingresos desde casa', 'Tener clientes que recomienden tu trabajo', 'Sentirte orgullosa de tus creaciones'];
export function ResultsSection() {
  const [ref, isVisible] = useReveal();
  return <section className="py-12 md:py-16 px-6 bg-gradient-to-b from-[#fff8f9] to-[#fce7e9]/40" data-id="element-177">
      <div className="max-w-4xl mx-auto" data-id="element-178">
        <div className="text-center mb-8" data-id="element-179">
          <span className="inline-block text-[#e89aaa] text-xs font-bold tracking-[0.25em] uppercase mb-3" data-id="element-180">
            ♡ Tu Visión ♡
          </span>
          <h2 className="text-2xl md:text-4xl font-serif font-bold text-[#6b4f3a]" data-id="element-181">
            Imaginá <span className="italic text-[#e89aaa]" data-id="element-182">poder…</span>
          </h2>
        </div>

        <div ref={ref} className={`reveal grid grid-cols-1 sm:grid-cols-2 gap-4 ${isVisible ? 'is-visible' : ''}`} data-id="element-183">
          {DREAMS.map((dream, i) => <div key={i} className="flex items-start gap-4 bg-white rounded-2xl p-6 border border-[#f4b6c2]/30 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all" data-id="element-184">
              <span className="text-2xl shrink-0" data-id="element-185">✨</span>
              <span className="text-[#6b4f3a] text-base md:text-lg font-medium" data-id="element-186">
                {dream}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}